import React from 'react';
import { Box, Typography, Link } from '@mui/material';

const Footer = () => {
    return (
        <Box
            sx={{
                py: 3,
                backgroundColor: '#333',
                color: '#fff',
                textAlign: 'center',
                mt: 'auto',
            }}
        >
            <Typography variant="body1">
                &copy; {new Date().getFullYear()} Leben in Deutschland (
                Einbürgerungstest )
            </Typography>
            <Box sx={{ mt: 1 }}>
                <Link
                    href="https://cheedge.leeindeutschland.de/"
                    target="_blank"
                    underline="hover"
                    color="inherit"
                    sx={{ mx: 1 }}
                >
                    Cheedge Lee
                </Link>
            </Box>
        </Box>
    );
};

export default Footer;
